import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Input,
  FormGroup,
  Label,
  Button,
  Spinner,
  Alert
} from "reactstrap";
import { useParams } from "react-router-dom";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import updateEpisode from "common/realBackend/blog/updateEpisode"; // Change from updateBook to updateEpisode

import updateStory from "common/realBackend/blog/updateBook";

import getStoryById from "common/realBackend/blog/getBlogById"; // Modify to get story by ID
import getEpisodeById from "common/realBackend/blog/getEpisodeById"; // New function to fetch episode by ID
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { extractDifference } from "helpers/extract-differemce";

const StoryUpdate = ({ onUpdateSuccess }) => {
  const { type, id, episodeId } = useParams(); // Destructure to get type, id, and episodeId
  const [existingStory, setExistingStory] = useState(null);
  const [existingEpisode, setExistingEpisode] = useState(null);
  const [coverImagePreview, setCoverImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  // Validation schema
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Story Title is required"),
    type: Yup.string().required("Story Type is required"),
    excerpt: Yup.string().required("Story Description is required"),
    image: Yup.mixed().nullable(),
  });

  useEffect(() => {
    const fetchData = async () => {
      try {

        const storyData = await getStoryById(id);
        setExistingStory(storyData.data);


        setCoverImagePreview(storyData.data.image);
      } catch (error) {
        console.error("Error fetching story/episode data:", error);
      }
    };
    fetchData();
  }, [id]);

  const handleSubmit = async (values) => {

    setLoading(true);
    try {
      const diff = extractDifference(existingStory, values);
      if (!Object.keys(diff).values()) {
        setAlertMessage("There is no change!");
        setAlertVisible(true);
        return;
      }

      await updateStory({
        id, ...values
      });


      setAlertMessage("Updated successfully!");
      setAlertVisible(true);
      if (onUpdateSuccess) onUpdateSuccess();
    } catch (error) {
      console.error(error)
      setAlertMessage("Error updating. Please try again.");
      setAlertVisible(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Stories" breadcrumbItem={episodeId ? "Update Episode" : "Update Story"} />

        {alertVisible && (
          <Alert color={alertMessage.includes("Error") ? "danger" : "success"}
            toggle={() => setAlertVisible(false)}
            style={{ position: 'fixed', top: '1rem', right: '1rem', zIndex: 1050 }}>
            {alertMessage}
          </Alert>
        )}

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <CardTitle className="mb-4">Update Story</CardTitle>
                {(existingStory || existingEpisode) ? (
                  <Formik
                    initialValues={{
                      name: existingStory?.name || "",
                      type: existingStory?.type || "",
                      excerpt: existingStory?.excerpt || "",
                      image: null,
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    {({ setFieldValue, values }) => (
                      <Form>
                        <FormGroup className="mb-4">
                          <Label htmlFor="name" className="col-form-label">Story Title</Label>
                          <Field id="name" name="name" as={Input} placeholder="Enter Title..." />
                          <ErrorMessage name="name" component="div" className="text-danger" />
                        </FormGroup>

                        <FormGroup className="mb-4">
                          <Label htmlFor="type" className="col-form-label">Story Type</Label>
                          <Field as="select" name="type" className="form-control">
                            <option value="">Select Story Type...</option>
                            <option value="series">Series</option>
                            <option value="one-shot">One-Shot</option>
                          </Field>
                          <ErrorMessage name="type" component="div" className="text-danger" />
                        </FormGroup>

                        <FormGroup className="mb-4">
                          <Label className="col-form-label">Description</Label>
                          <Field
                            as="textarea"
                            className="form-control"
                            rows="10"
                            placeholder="Enter story text..."
                            name="excerpt" // Formik will handle value and changes for 'storyText'
                          />
                          <ErrorMessage name="excerpt" component="div" className="text-danger" />
                        </FormGroup>

                        <FormGroup className="mb-4">
                          <Label className="col-form-label">Cover Image</Label>
                          <Input
                            type="file"
                            className="form-control"
                            onChange={(e) => {
                              const file = e.currentTarget.files[0];
                              setFieldValue("image", file);
                              setCoverImagePreview(URL.createObjectURL(file));
                            }}
                          />
                          {coverImagePreview && (
                            <div className="mt-2">
                              <img src={coverImagePreview} alt="Cover Preview" style={{ maxWidth: '250px', height: 'auto' }} />
                            </div>
                          )}
                          <ErrorMessage name="coverImage" component="div" className="text-danger" />
                        </FormGroup>

                        <Row className="justify-content-end">
                          <Col lg="10">
                            <Button type="submit" color="primary" disabled={loading}>
                              {loading ? <Spinner size="sm" /> : "Update Story"}
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                ) : (
                  <Spinner color="primary" />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default StoryUpdate;